
export enum SystemRole {
    All = 'all',
    Developer = 'Developer',
    SystemAdmin = 'SystemAdmin',
    SchoolAdmin = 'SchoolAdmin',

    // Admin/Editor Roles
    Certification = 'Certification',
    Experience = 'Experience',
    ESOL = 'ESOL',
    Education = 'Education',
    OutOfField = 'OutOfField',
    // StaffPortal = 'StaffPortal',
    PayrollAdmin = 'PayrollAdmin',

    // Page Specific Reader roles
    CertificationReader = 'CertificationReader',
    ExperienceReader = 'ExperienceReader',
    ESOLReader = 'ESOLReader',
    EducationReader = 'EducationReader',
    OutOfFieldReader = 'OutOfFieldReader',
    EvaluationsReader = 'EvaluationsReader'
}
